import API from 'libs/api';

import { SUPPORTED_ELEMENT_TYPES } from './EditPageElementModal.constants';
import { isLegacyFormBlock } from './components/EditFormBlock/EditFormBlock.utils';
import { BASE_SINGLE_IMAGE_DEFAULT_STYLES } from './components/EditImageBlock/components/SingleImageStyle/SingleImageStyle.constants';
import { FORM_BLOCK_ELEMENT_TYPE, IMAGE_BLOCK_ELEMENT_TYPE } from '../../constants/types';
import { addCollectionPropIfDefined } from '../../hooks/use-recipe-node-translator/generators/utils/props';
import { findElementComponentConfigurationIds } from '../../services/element';

function getDefaultElementState(elementType) {
  const defaultDataByElementType = {
    [IMAGE_BLOCK_ELEMENT_TYPE]: addCollectionPropIfDefined(
      { props: [] },
      'style',
      BASE_SINGLE_IMAGE_DEFAULT_STYLES,
    ),
  };
  return defaultDataByElementType[elementType] || {};
}

export function createElementStates(defaultElement, createStateFunc) {
  const { type: defaultElementType } = defaultElement;

  const isLegacyForm = isLegacyFormBlock(defaultElement);

  return SUPPORTED_ELEMENT_TYPES.reduce((state, elementType) => {
    if (
      elementType === defaultElementType ||
      (isLegacyForm && elementType === FORM_BLOCK_ELEMENT_TYPE)
    ) {
      return { ...state, [elementType]: defaultElement };
    }

    return {
      ...state,
      [elementType]: createStateFunc(elementType, getDefaultElementState(elementType)),
    };
  }, {});
}

export async function deleteCustomPageElement(element) {
  const { componentConfigurationId } = element;
  const promises = [];

  if (componentConfigurationId) {
    promises.push(API.removeCustomPageContent(componentConfigurationId));
  }

  const componentConfigurationIds = findElementComponentConfigurationIds(element);
  componentConfigurationIds.forEach((id) => {
    promises.push(API.removeCustomPageContent(id));
  });

  await Promise.all(promises);
}

export async function deleteContentForPanel(panel) {
  const ids = findElementComponentConfigurationIds(panel);
  return Promise.all(ids.map((currentId) => API.removeCustomPageContent(currentId)));
}

export function requestElementDelete(actionLoading, setShowDeleteConfirmModal) {
  if (actionLoading) {
    return;
  }

  setShowDeleteConfirmModal(true);
}

export function cancelElementDelete(deleteLoading, setShowDeleteConfirmModal) {
  if (deleteLoading) {
    return;
  }

  setShowDeleteConfirmModal(false);
}

export function cancelElementEdit(actionLoading, onCancel) {
  if (actionLoading) {
    return;
  }

  onCancel();
}
